// extracted by mini-css-extract-plugin
export default {"container":"vz-z"};